import { Navigate, Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AddNumberFromAppAccessLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/layout/AddNumberFromAppAccessLayout'
import { NewInboxRoutes } from 'pages/settings/pages/inboxes/route/type'
import { AddNumberFromAppLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/layout/AddNumberFromAppLayout'
import { SelectAppAndNumbers } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/ui/SelectAppAndNumbers/SelectAppAndNumbers'
import { Payment } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/ui/Payment/Payment'

export const AddNumberFromAppRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<AddNumberFromAppAccessLayout />}>
        <Route element={<AddNumberFromAppLayout />}>
          <Route index element={<Navigate to={NewInboxRoutes.selectAppAndNumbers} replace />} />
          <Route path={NewInboxRoutes.selectAppAndNumbers} element={<SelectAppAndNumbers />} />
          <Route path={NewInboxRoutes.payment} element={<Payment />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
